import { configureStore } from '@reduxjs/toolkit';
import meterInfoReducer from './meterInfo';

const store = configureStore({
  reducer: {
    meterInfo: meterInfoReducer
  },
});

export default store;